import { classNames } from '@panwds/tailwindcss';
import React from 'react';
/**
 * This is a layout component with additional margins
 * enforced by the Palo Design System
 *
 * Use the Card component directly if you want to control spacing. Standard design system following is tw-m-4
 *
 * ### Import Guide
 *
 * ```jsx
 * import { CardLayout } from '@panwds/react-ui';
 * ```
 */
export function CardLayout({ addClassName, children, style = {}, ...passThrough }) {
    const className = classNames('tw-flex tw-flex-col tw-p-4 border-none', addClassName);
    return (React.createElement("div", { "data-testid": "card-layout", style: style, className: className, ...passThrough }, children));
}
//# sourceMappingURL=CardLayout.js.map